// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { mobileTippyStyle } from "@rpsc/App/ComponentExtensions/Tippy/TippyPopupExtensions";
import {
    hideLoadingOverlay,
    xngLoadingOverlayUtilitiesStyles,
} from "@rpsc/App/Components/Common/XngLoadingOverlayUtilities";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { xBaseTheme } from "@rpsc/XDL/types";
import { styledScrollbar, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

export default {
    css: css`
        ${xngLoadingOverlayUtilitiesStyles}
        ${hideLoadingOverlay}
        body {
            /* Better Font Rendering */
            font-variant-ligatures: no-common-ligatures;
            text-rendering: optimizeLegibility;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            font-family: ${fontConfig.fontFamily};
        }
        [data-tippy-root] {
            z-index: ${getProp("theme.zIndex.tippy")} !important;
        }
        ${mobileTippyStyle}

        // This style to fix an issue with Google Places autocomplete
        .pac-container {
            z-index: 10000 !important;
        }
        .zls-sptwndw,
        .zsiq_floatmain {
            display: none;
        }
        @media print {
            .zls-sptwndw,
            .zsiq_floatmain {
                display: none !important;
            }
        }

        .video-wrapper {
            width: 100%;
            gap: 16px;
            flex-wrap: wrap;
            display: flex;
        }
        .video-wrapper .video-item {
            display: flex;
        }
        .video-item > iframe {
            position: relative;
            border-radius: 4px;
            overflow: hidden;
            height: 212px;
            width: 376px;
            ${xScreen("lte", "lg")} {
                height: 179px;
                width: 317px;
            }
            ${xScreen("lte", "md")} {
                width: auto;
            }
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        }
    `,
} as xBaseTheme["globalStyle"];
